
import React, { useEffect, useState } from "react";
import axios from "axios";
import { format } from "date-fns";
import { Form } from "react-bootstrap";
import toast from "react-hot-toast";


const EditDepartment = ({ show, handleClose, employeeData, onDepartmentUpdated }) => {
    const [formData, setFormData] = useState({
        name: "",
        description: "",
        headName: "",
        headId: "",
        headEmail: "",
        headPhoneNumber: "",
        status: "Active",
    });
    const [showDropdown, setShowDropdown] = useState(false);
    const [employees, setEmployees] = useState([]); // store employee list
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const todayDate = format(new Date(), "yyyy-MM-dd");
    const [selectedDate] = useState(todayDate);

    // Populate form with existing department data
    useEffect(() => {
        if (employeeData) {
            setFormData({
                name: employeeData.name || "",
                description: employeeData.description || "",
                headName: employeeData.headName || "",
                headId: employeeData.headId || "",
                headEmail: employeeData.headEmail || "",
                headPhoneNumber: employeeData.headPhoneNumber || "",
                status: employeeData.status || "Active",
            });
        }
    }, [employeeData]);

    // Fetch employee list for dropdown
    const fetchWeeklyData = async () => {
        try {
            // const url = `${process.env.REACT_APP_BACKEND_URL}/api/v1/timesheets/employees/date?date=${selectedDate}`;
            const url = `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/list`;
            const response = await fetch(url, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });

            const data = await response.json();
            const records = Array.isArray(data) ? data : data?.content || [];
            setEmployees(records);

        } catch (error) {
            console.error("Error fetching attendance data:", error);
        }
    };

    // Fetch employees when modal opens
    useEffect(() => {
        if (show) fetchWeeklyData();
    }, [show]);

    // Handle form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // Handle save (update department)
    const handleSave = async () => {
        if (!employeeData?.departmentId) {
            setError("Department ID is missing.");
            return;
        }

        try {
            setLoading(true);
            setError("");

            const token = localStorage.getItem("token");
            const deptId = employeeData.departmentId;
            const payload = {
                name: formData.name,
                description: formData.description,
                headId: formData.headId, // ✅ send empId
                headName: formData.headName,
                headEmail: formData.headEmail,
                headPhoneNumber: formData.headPhoneNumber,
                status: formData.status,
            };

            const response = await axios.patch(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/depts/${deptId}`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log("Department Updated Payload", payload)
            console.log("✅ Department Updated Successfully:", response.data);
            toast.success("Department updated successfully!");
            if (onDepartmentUpdated) onDepartmentUpdated(); // ✅ Refresh list in parent
            handleClose();
        } catch (err) {
            console.error("❌ Error updating department:", err);
            setError(err.response?.data?.message || "Failed to update department.");
        } finally {
            setLoading(false);
        }
    };

    if (!show) return null;

    return (
        <>

            <div className="modal-backdrop fade show">
            </div>
            <div
                className="modal show d-block scrollable"
                tabIndex="-1"
                style={{
                    background: "rgba(0,0,0,0.5)",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    zIndex: 1055,
                    overflowY: "auto",
                }}
            >
                <div
                    className="modal-dialog modal-dialog-centered"
                    style={{
                        maxWidth: "600px",
                        width: "100%",
                        boxShadow: "0px 4px 14px 0px #0000000D",
                    }}
                >
                    <div
                        className="modal-content p-4 rounded-4 shadow-sm"
                        style={{
                            maxHeight: "90vh",
                            overflowY: "auto",
                        }}
                    >
                        <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                            <h5 className="fw-semibold mb-0">Edit Department</h5>
                            <button type="button" className="btn-close" onClick={handleClose}></button>
                        </div>

                        {error && <div className="alert alert-danger py-2">{error}</div>}

                        {/* Department Name */}
                        <div className="mb-3">
                            <label className="form-label fw-semibold">Department Name</label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        {/* Description */}
                        <div className="mb-3">
                            <label className="form-label fw-semibold">Description</label>
                            <textarea
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                className="form-control"
                                rows={3}
                            />
                        </div>

                        {/* Head of Department Dropdown */}

                        <div className="mb-3">
                            <label className="form-label fw-semibold">Head of Department</label>
                            <select
                                className="form-select"
                                name="headId"
                                value={formData.headId}
                                onChange={(e) => {
                                    const selected = employees.find((emp) => emp.empId === e.target.value);
                                    setFormData((prev) => ({
                                        ...prev,
                                        headId: e.target.value,
                                        headName: `${selected?.firstName || ""} ${selected?.lastName || ""}`,
                                        headEmail: selected?.officeEmail || selected?.personalEmail || "",
                                        headPhoneNumber: selected?.mobileNumber || "",
                                    }));
                                }}
                            >
                                <option value="">Select Employee</option>
                                {employees.map((emp) => (
                                    <option key={emp.empId} value={emp.empId}>
                                        {emp.firstName} {emp.lastName}
                                    </option>
                                ))}
                            </select>
                        </div>




                        {/* Status Toggle */}
                        <Form.Group
                            className="mb-3 p-2"
                            style={{
                                border: "1px solid #DEDEDE",
                                borderRadius: "10px",
                                background:
                                    formData.status === "Active" ? "#D9FFD4" : "#FEF2F2",
                                color:
                                    formData.status === "Active" ? "#1EA70C" : "#A70C0C",
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                            }}
                        >
                            <Form.Label className="mb-0" style={{ color: '#000000' }}>Status :</Form.Label>
                            <span style={{
                                background:
                                    formData.status === "Active" ? "#D9FFD4" : "#FEF2F2",
                                color:
                                    formData.status === "Active" ? "#1EA70C" : "#A70C0C",
                            }}>
                                {formData.status === "Active" ? "Active" : "Inactive"}
                            </span>
                            <Form.Check
                                type="switch"
                                id="status-switch"
                                checked={formData.status === "Active"}
                                onChange={(e) =>
                                    setFormData({
                                        ...formData,
                                        status: e.target.checked ? "Active" : "Inactive",
                                    })
                                }
                                style={{ marginLeft: "auto" }}
                            />
                        </Form.Group>

                        {/* Action Buttons */}
                        <div className="d-flex justify-content-end gap-2 mt-4">
                            <button
                                className="btn btn-outline-secondary"
                                onClick={handleClose}
                                disabled={loading}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn create-btn"
                                onClick={handleSave}
                                disabled={loading}
                            >
                                {loading ? "Saving..." : "Save Changes"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditDepartment;

